import { Injectable } from '@angular/core';

import { IChatwootInboxItem } from 'src/app/shared/interfaces/IChatwoot';

/**
 * Snapshot del estado de la lista de conversaciones del panel del FAB.
 * El contenido del p-drawer se destruye al cerrar el panel (@if (panelVisible())),
 * así que al "volver al listado" desde un chat la lista se re-crea desde cero.
 * Este snapshot permite hidratarla al instante (sin "Cargando conversaciones…")
 * y refrescar en silencio por detrás.
 */
export interface ChatPanelSnapshot {
    items: IChatwootInboxItem[];
    totalNoLeidos: number;
    page: number;
    finLista: boolean;
    estado: string;
    soloNoLeidos: boolean;
    busqueda: string;
    soloMias: boolean;
    soloCampanas: boolean;
    /** epoch ms de la última carga exitosa; snapshots viejos se descartan. */
    guardadoEn: number;
}

/** Vigencia máxima del snapshot (ms): más viejo → carga normal con spinner. */
const SNAPSHOT_TTL_MS = 5 * 60_000;

@Injectable({ providedIn: 'root' })
export class ChatGlobalPanelStateService {
    private snapshot: ChatPanelSnapshot | null = null;

    guardar(snapshot: ChatPanelSnapshot): void {
        this.snapshot = snapshot;
    }

    /** Snapshot vigente o null (expirado/inexistente). No lo consume: sigue disponible. */
    obtener(): ChatPanelSnapshot | null {
        if (!this.snapshot) return null;
        if (Date.now() - this.snapshot.guardadoEn > SNAPSHOT_TTL_MS) {
            this.snapshot = null;
            return null;
        }
        return this.snapshot;
    }

    limpiar(): void {
        this.snapshot = null;
    }
}
